import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'decodeHtmlEntities'
})

export class DecodeHtmlEntities implements PipeTransform {
    transform(value: any): any {
        if (!value) return;
        const txt = document.createElement("textarea");
        txt.innerHTML = value;
        
        return txt.value;
    }
}
